export default __webpack_public_path__ + "static/media/CL11.a577c6c8.mp3";